import { add, Duration } from 'date-fns';
import React, { useMemo } from 'react';
import { Typography } from '@ag1/ui';
import { useLocale } from 'shared/hooks/useLocale';
import { useQueryGetCommonContentData } from 'state/studio/commonContentData/getCommonContentData';
import { getStringWithVariables } from 'shared/utils/addVariablesToString';
import { useDateFormatting } from 'state/hooks/useDateFormatString';
import styles from './styles.module.scss';

type ChangeDateDatepickerInfoProps = {
  value: Date;
  durationForSubscription: Duration | null;
};

export const ActivateSubscriptionModalDatepickerInfo = ({
  value,
  durationForSubscription
}: ChangeDateDatepickerInfoProps) => {
  const futureOrderDateFirst = useMemo(
    () => (durationForSubscription ? add(value, durationForSubscription) : null),
    [durationForSubscription, value]
  );

  const locale = useLocale();
  const { data: commonContent } = useQueryGetCommonContentData({ locale });
  const getFormattedDate = useDateFormatting();

  if (!commonContent) {
    return null;
  }

  const BANNERS = commonContent.banners;

  return (
    <div className={styles.content}>
      <Typography variant="portalText" size="1" weight="400" color="black-new" noPadding>
        {BANNERS.nextOrderInfo} {getFormattedDate(value)}
      </Typography>
      {futureOrderDateFirst && (
        <Typography variant="portalCaption" size="1" weight="400" color="black-new" noPadding>
          {getStringWithVariables(
            BANNERS.nextOrderDescription,
            getFormattedDate(futureOrderDateFirst),
            'date'
          )}
        </Typography>
      )}
    </div>
  );
};
